// extracted by mini-css-extract-plugin
module.exports = {"container":"SocialLogin_container__h2unn"};